import { render, staticRenderFns } from "./CoreSelectionList.vue?vue&type=template&id=142ed920&scoped=true&"
import script from "./CoreSelectionList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreSelectionList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreSelectionList.vue?vue&type=style&index=0&id=142ed920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ed920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142ed920')) {
      api.createRecord('142ed920', component.options)
    } else {
      api.reload('142ed920', component.options)
    }
    module.hot.accept("./CoreSelectionList.vue?vue&type=template&id=142ed920&scoped=true&", function () {
      api.rerender('142ed920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSelectionList/CoreSelectionList.vue"
export default component.exports